import { Badge } from "@apex/component-library";
import { BadgeProps, Box } from "@chakra-ui/react";

import { Status } from "../../types";

interface StatusBadgeProps extends BadgeProps {
  value: Status;
}
const boxProps = {
  display: "flex",
  h: "100%",
  alignItems: "center",
};

const badgeProps = {
  h: "2rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export const StatusBadge = ({ value, ...restProps }: StatusBadgeProps) => {
  const getBadge = (value: Status) => {
    switch (value) {
      case Status.Open:
        return (
          <Badge
            {...badgeProps}
            {...restProps}
            colorScheme="green"
            data-testid="status-badge-open"
          >
            {value}
          </Badge>
        );
      case Status.Closed:
        return (
          <Badge
            {...badgeProps}
            {...restProps}
            colorScheme="red"
            data-testid="status-badge-closed"
          >
            {value}
          </Badge>
        );
      default:
        return (
          <Badge {...badgeProps} {...restProps} colorScheme="gray">
            {value}
          </Badge>
        );
    }
  };
  return <Box {...boxProps}>{getBadge(value)}</Box>;
};
